let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lhBry")).then(() => parcelRequire('65n82'));